import React, { Component } from 'react';
import Draggable from 'react-draggable';
import Viewer from './Viewer';
import './Feed.css';
import ReactTimeout from 'react-timeout';
// this.props.imageFeed available

class Feed extends Component {
	
	eventLogger = (e: MouseEvent, data: Object) => {
		console.log('Event: ', event);
		console.log('Data: ', data);
	};
  
  
	constructor(props) {
		super(props);
		this.state = {
			data: [],
			active:0,
			date: new Date()
		};
		this.transitionTime = 800;
		this.windowWidth = window.innerWidth;
		this.windowHeight = window.innerHeight;
		if(this.windowWidth < 420) {
			this.disableDrag = true;
			this.setx = 0;
		}else{
			this.disableDrag = false;
			this.setx = this.windowWidth-300;
		}
	}
	
    componentDidMount() {
	    let headers = new Headers();
	    headers.append("Authorization", "Basic " + btoa("Thursday:Ch1ld")); 
	    headers.append("Content-Type", "application/x-www-form-urlencoded");
      
        fetch(this.props.imageFeed, {headers: headers})
            .then( (response) => {
                return response.json() })   
                    .then( (json) => {
                        this.setState({data: this.shuffle(json)});
						console.log(this.state.data[0]);
                    });
		this.tick();
    };
    
	shuffle(o) {
		for(var j, x, i = o.length; i; j = parseInt(Math.random() * i, 10), x = o[--i], o[i] = o[j], o[j] = x);
		return o;
	}
	
    
	nextPic() {
		this.setState((prevState, props) => {
			let newState = {
				date: new Date()
			}
			if(prevState.active < this.state.data.length){
				newState.active = prevState.active + 1;
			}else{
				newState.data = this.shuffle(prevState.data);
				newState.active = 0;
			}
			return newState;
		});
		this.tick();
		
	}
	
	tick(){
		this.props.setTimeout(this.nextPic.bind(this), (Math.random() * 25000) + 8000);
	}
	
	render() {
		return (
			<Draggable
			axis="both"
			handle=".Collapsible__trigger-sibling, .feed-label"
			defaultPosition={{x: this.setx, y: this.windowHeight}}
			position={null}
			bounds='parent'
			//grid={[25, 25]}
			zIndex={100}
			disabled={this.disableDrag} 
			onStart={this.handleStart}
			onDrag={this.handleDrag}
			onStop={this.handleStop}>
				<div>
					<div className='feed-box'>
						<Viewer data={this.state.data} active={this.state.active} transitionTime={this.transitionTime} date={this.state.date} />
					    
					</div>
				</div>
			</Draggable>
		);
	};
}

export default ReactTimeout(Feed);


// WEBPACK FOOTER //
// ./src/Feed.js